<template lang="html">
  <v-container class='fluid'>
    <v-layout align-center justify-center>
      <v-flex xs10>

        <v-card class="text-xs-center" v-if="administrador === true">
          <basic-toolbar :title="'Aprovar, devolver para o coordenador ou inabilitar ações de extensão aguardando aprovação'"></basic-toolbar>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-text-field append-icon="filter_list" label="Filtrar resultados" v-model="search"></v-text-field>
          </v-card-title>
          <v-card-text>
            <v-data-table
            :headers="headers"
            :items="listaProjetos"
            :search="search"
            :no-data-text="'Nenhum projeto encontrado'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >
              <template v-slot:item.titulo="props">
                <router-link :to="{ name: 'ProjetoFormulario', params: { idProjeto: props.item.idProjeto }}">{{ props.item.titulo }}</router-link>
              </template>

              <!-- Ícones de "Aprovar", "Devolver" e "Inabilitar" da coluna "Opções" -->
              <template v-slot:item.opcoes="props">

                <!-- Ícone de "Aprovar" -->
                <c-tooltip-btn
                icon="done_outline"
                color="green"
                tooltip="Aprovar"
                @click="goAprovarProjeto(props.item.idProjeto)"
                ></c-tooltip-btn>

                <!-- Ícone de "Devolver" -->
                <c-tooltip-btn
                icon="not_interested"
                color="red"
                tooltip="Devolver"
                @click="goDevolverProjeto(props.item.idProjeto)"
                ></c-tooltip-btn>

                <!-- Ícone de "Inabilitar" -->
                <c-tooltip-btn
                icon="cancel"
                color="black"
                tooltip="Inabilitar"
                @click="goInabilitarProjeto(props.item.idProjeto)"
                ></c-tooltip-btn>

              </template>
              
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaProjetos.length }} projetos
              </template>
            </v-data-table>
            <br>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import BasicToolbar from '@/components/toolbars/basic-toolbar'
  import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
  import TootipButton from '@/components/c-tooltip-btn'
  import DataMenu from '@/components/c-date-menu'
  import dates from '@/utils/dates'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['idProjeto'],
    data: () => ({
      formularioValido: false,
      dates: dates,
      pesquisaAvancada: false,
      pesquisa: {
        situacao: [16]
      },
      listaProjetos: [],
      regrasBasicas: [
        (input) => !!input || 'Este campo é obrigatório'
      ],
      search: null,
      sortBy: 'dtCriacao',
      sortDesc: true,
      itemsPerPage: -1,
      opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
      headers: [
        { text: 'Número', align: 'center', value: 'idProjeto' },
        { text: 'Título', align: 'center', value: 'titulo' },
        { text: 'Classificação Primária', align: 'center', value: 'classificacaoPrimaria' },
        { text: 'Classificação Secundária', align: 'center', value: 'classificacaoSecundaria' },
        { text: 'Situação', align: 'center', value: 'situacao' },
        { text: 'Coordenador', align: 'center', value: 'nomeCoordenador' },
        { text: 'Opções', align: 'center', value: 'opcoes' }
      ]
    }),
    computed: {
      ...mapGetters('auth', ['logged', 'username', 'nome', 'administrador', 'usuarioPROEX', 'permissaoCriarProjetoExtensao'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      limpar () {
        this.pesquisa = { tipoProjeto: 39725 }
      },
      pesquisar () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' })
        projetos.getConsultaProjetos(this.pesquisa)
        .then(response => {
          this.listaProjetos = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.listaProjetos = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projetos.' })
        })
      },
      goAprovarProjeto (idProjetoParam) {
        this.$router.push({name: 'AprovarProjeto', params: {idProjeto: idProjetoParam}})
      },
      goDevolverProjeto (idProjetoParam) {
        this.$router.push({name: 'DevolverProjeto', params: {idProjeto: idProjetoParam}})
      },
      goInabilitarProjeto (idProjetoParam) {
        this.$router.push({name: 'InabilitarProjeto', params: {idProjeto: idProjetoParam}})
      },
      truncate (string, limit) {
        if (string.length > limit) return string.substring(0, limit) + '...'
        else return string
      },
      carregarUnidades: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' })
        projetos.getUnidadesExtensao()
        .then(response => {
          this.listaUnidades = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.listaUnidades = []
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando unidades.' })
        })
      },
      opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
        })
      },
      obterClassificacoes: function (itemTabela, aqui, atributo) {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo })
        projetos.getClassificacoesPossiveis(itemTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificação ' + atributo })
        })
      },
      carregarCampos: function () {
        this.opcoesTabelaEstruturada(6011, this, 'listaSituacao')
        this.opcoesTabelaEstruturada(6002, this, 'listaTipoPublico')
        this.carregarUnidades()
        this.obterClassificacoes(100, this, 'listaAreatematica')
        this.obterClassificacoes(110, this, 'listaAreatematicaAfim')
        this.obterClassificacoes(111, this, 'listaLinhaExtensao')
        this.obterClassificacoes(112, this, 'listaGrandeArea')
      },
      abrirPesquisaAvancada () {
        this.carregarCampos()
        this.pesquisaAvancada = true
      },
      fecharPesquisaAvancada () {
        this.pesquisaAvancada = false
      }
    },
    mounted () {
      // this.obterClassificacoes(90, this, 'listaTipo')
      this.obterClassificacoes(91, this, 'listaSubtipo')
      this.pesquisar()
    },
    components: {
      'basic-toolbar': BasicToolbar,
      'tooltip': ToolTip,
      'c-tooltip-btn': TootipButton,
      'c-date-menu': DataMenu
    }
  }
</script>

<style lang="css">
  .menu {
    display: block !important;
  }

  .no-resize div textarea{
    resize: none;
  }
  .input-group__icon-cb {
    cursor: pointer !important;
  }
</style>



// WEBPACK FOOTER //
// projetos-aprovar-tabela.vue?3a8a0a14